import React from "react";
import PropTypes from "prop-types";

const Text = (props) => {
  const style = {
    fontSize: props.size,
    color: props.color,
    fontWeight: props.fontWeight,
    fontStyle: props.fontStyle,
    fontFamily: "AvenirNext",
    lineheight: props.lineHeight,
  };

  return (
    <span style={style} {...props}>
      {props.children}
    </span>
  );
};

Text.propTypes = {
  size: PropTypes.string,
  fontWeight: PropTypes.number,
  fontStyle: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  lineheight: PropTypes.string,
};

Text.defaultProps = {
  size: "16px",
  fontWeight: 500,
  fontStyle: "normal",
  color: "black",
  className: "",
  lineheight: "18px",
};

export default Text;
